import AdminLeaderboardPage from "./AdminLeaderboardPage";

export default function InstructorLeaderboardPage() {
  return <AdminLeaderboardPage endpoint="/instructor/students" />;
}
